export default class CreateProductMigrationRequest {
    name: string;
    fromIsCurrentProductIssue: boolean = false;
    fromProductId: string;
    fromProductIssueId: string;
    toProductId: string;
    toProductIssueId: string;
}